<template>
  <section class="section white-bg">
    <div class="container">
      <div class="section-heading">
        <h2><span>Tính năng của hệ thống</span></h2>
        <p class="sub-title">
          Những tính năng ưu việt của hệ thống quản lý giải đấu cầu lông EZBadminton
        </p>
      </div>
      <div class="row justify-content-center">
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="work-grid coaching-grid w-100">
            <div class="work-icon">
              <div class="work-icon-inner">
                <img
                  src="@/assets/img/icons/coache-icon-01.svg"
                  class="img-fluid"
                  alt="Icon"
                />
              </div>
            </div>
            <div class="work-content">
              <h3>Tổ chức giải</h3>
              <p>
                Quản lý và tổ chức giải đấu chuyên nghiệp với quy trình linh hoạt và dễ dàng.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="work-grid coaching-grid w-100">
            <div class="work-icon">
              <div class="work-icon-inner">
                <img
                  src="@/assets/img/icons/coache-icon-03.svg"
                  class="img-fluid"
                  alt="Icon"
                />
              </div>
            </div>
            <div class="work-content">
              <h3>Thi Đấu </h3>
              <p>
                Theo dõi và cập nhật lịch thi đấu, diễn biến các trận đấu một cách chính xác và nhanh chóng.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="work-grid coaching-grid w-100">
            <div class="work-icon">
              <div class="work-icon-inner">
                <img
                  src="@/assets/img/icons/coache-icon-02.svg"
                  class="img-fluid"
                  alt="Icon"
                />
              </div>
            </div>
            <div class="work-content">
              <h3> App Trọng Tài</h3>
              <p>
                Ứng dụng hỗ trợ trọng tài điều hành trận đấu chuyên nghiệp, giúp ghi nhận kết quả chính xác.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="work-grid coaching-grid w-100">
            <div class="work-icon">
              <div class="work-icon-inner">
                <img
                  src="@/assets/img/icons/coache-icon-04.svg"
                  class="img-fluid"
                  alt="Icon"
                />
              </div>
            </div>
            <div class="work-content">
              <h3>Kết Quả Thi Đấu </h3>
              <p>
                Cập nhật kết quả từng trận đấu theo thời gian thực, minh bạch và chi tiết.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="work-grid coaching-grid w-100">
            <div class="work-icon">
              <div class="work-icon-inner">
                <img
                  src="@/assets/img/icons/coache-icon-05.svg"
                  class="img-fluid"
                  alt="Icon"
                />
              </div>
            </div>
            <div class="work-content">
              <h3>Xếp Hạng Giải Đấu </h3>
              <p>
                Hệ thống xếp hạng tự động giúp theo dõi thành tích của vận động viên và đội tuyển.
              </p>
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 d-flex">
          <div class="work-grid coaching-grid w-100">
            <div class="work-icon">
              <div class="work-icon-inner">
                <img
                  src="@/assets/img/icons/coache-icon-06.svg"
                  class="img-fluid"
                  alt="Icon"
                />
              </div>
            </div>
            <div class="work-content">
              <h3>Thông Tin Vận Động Viên & Giải Đấu
              </h3>
              <p>
                Hồ sơ vận động viên chi tiết cùng thông tin giải đấu đầy đủ để tiện theo dõi.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
